<template>
	<el-container style="height: 100%; position: relative; flex-direction: column">
		<PageHeader></PageHeader>
		<keep-alive>
			<router-view v-if="$route.meta.keepAlive" class="layout-main"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive" class="layout-main" />
		<!--    :style="{ minHeight: mainHeight + 'px' }"-->
		<PageFooter v-if="!isAiPage"></PageFooter>
		<PageFloat v-if="!isAiPage"></PageFloat>
		<PageFloatSimple v-if="isAiPage"></PageFloatSimple>
		<!-- 旧版登录组件，兼容 setLoginShow 调用 -->
		<LoginBox ref="loginbox" @success="onLoginSuccess"></LoginBox>
	</el-container>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageFooter from '@/components/PageFooter';
import PageFloat from '@/components/PageFloat/index.vue';
import PageFloatSimple from '@/components/PageFloatSimple/index.vue';
import LoginBox from '@/components/LoginBox/index.vue';
import { mapGetters } from 'vuex';
export default {
	name: 'Index',
	components: {
		PageFloat,
		PageFloatSimple,
		PageFooter,
		PageHeader,
		LoginBox
	},
	data() {
		return {
			mainHeight: 0
		};
	},
	created() {
		this.mainHeight = window.innerHeight - 100;
	},
	computed: {
		isAiPage() {
			const routeNameList = this.$store.getters['Settings/sNoFooterRouteList'];
			const routeName = this.$route.name;
			return routeNameList.includes(routeName);
		},
		isStandardsPdf() {
			return this.$route.name === 'StandardsPdf';
		},
		...mapGetters('User', ['uinfo', 'uisLogin'])
	},
	watch: {
		$route(to, from) {
			// 路由变化时重新评估右键行为
			if (this.isStandardsPdf) {
				document.addEventListener('contextmenu', this.handleRightClick);
			} else {
				document.removeEventListener('contextmenu', this.handleRightClick);
			}
		}
	},
	methods: {
		onLoginSuccess() {
			// 登录成功回调
		},
		handleRightClick(event) {
			if (this.isStandardsPdf) {
				event.preventDefault();
				return false;
			}
		}
	},
	mounted() {
		// 添加右键事件监听
		document.addEventListener('contextmenu', this.handleRightClick);
	},
	beforeDestroy() {
		// 移除右键事件监听
		document.removeEventListener('contextmenu', this.handleRightClick);
	}
};
</script>

<style>
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
}

html,
body,
#app {
	width: 100%;
	/* height: 100%; */
	background: #f8fafc;
}

.layout-main {
	flex: 1;
	margin-top: 70px !important;
}

@media screen and (max-width: 767px) {
	.layout-main {
		margin-top: 50px !important;
	}
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
	.layout-main {
		margin-top: 60px !important;
	}
}

@media screen and (min-width: 1025px) and (max-width: 1366px) {
    .layout-main {
		margin-top: 65px !important;
	}
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
    .layout-main {
		margin-top: 68px !important;
	}
}

@media screen and (min-width: 1601px) and (max-width: 1920px) {
    .layout-main {
		margin-top: 70px !important;
	}
}

@media screen and (min-width: 1921px) {
	.layout-main {
		margin-top: 75px !important;
	}
}

.to-top {
	padding: 10px;
	background: rgba(0, 153, 229, 0.7);
	color: #fff;
	text-align: center;
	border-radius: 2px;
}
</style>
